import { generateJsonWebToken, checkAndGetSessionStorageValue } from "../../../../features/utils";
export async function getTriageServiceCategoriesFromAnswers({ actions,lang }) {

  // Internally, the API returns a "score" in response to answers
  console.log('*********************por obtener el score y services*********************')
  const success = await actions.getTriageScoreFromAnswers(lang)
  console.log('*********************Obtuve *********************')
  // Then we can get service categories, also called "care options"

  if (success) {
    await actions.getTriageServiceCategoriesByScore()
  }
}

export async function getTriageServiceCategoriesByScore({ state, actions }) {

  const { triageRequest } = state
  const {
    location: { parts = {} },
    selectedCareOptionScore
  } = triageRequest
  const { country = 'United States' } = parts
  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")
  const data = {
    country,
    score: selectedCareOptionScore,
    jwtAccessToken : jwtAccess_Token,
    accessToken : access_Token,
  }

  await actions.sendTriageRequest({
    action: 'getServiceCategoriesByScore',
    data
  })
}
